import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { RackSuggestionDto } from './rack-suggestion.dto';

export class RackSuggestionsResponseModel extends GlobalResponseObject {
    data?: RackSuggestionDto;

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status:boolean, errorCode:number, internalMessage:string, data?: RackSuggestionDto){
        super(status,errorCode,internalMessage);
        this.data = data;
    }
}